import { removeFromLocalStorage } from '@/shared'

export const clearUserData = () => {
	removeFromLocalStorage('isLogged')
	removeFromLocalStorage('activeRole')
	removeFromLocalStorage('roles')
	removeFromLocalStorage('activeCompany')
}
